import React, { useState, useEffect } from 'react';
import { fetchUpcomingPerformance } from '../services/strapi';

const UpcomingPerformance = () => {
  const [performance, setPerformance] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getPerformance = async () => {
      try {
        setLoading(true);
        const data = await fetchUpcomingPerformance();
        console.log(data)
        setPerformance(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getPerformance();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {performance && (
        <div>
          <h2>{performance.Title}</h2>
          <p>{performance.Description}</p>
        </div>
      )}
    </div>
  );
};

export default UpcomingPerformance;